import { keyframes } from '@emotion/react'
import { Box, Typography } from '@mui/material'
import styled from '@mui/system/styled'

import { theme } from 'styles/theme'

const gradientShift = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`

export const Wrapper = styled(Box)(({ theme: muiTheme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 16,
  width: '100%',
  margin: '24px 0 8px 0',
  justifyContent: 'center',

  [muiTheme.breakpoints.down(950)]: {
    margin: '16px 0 8px 0',
    justifyContent: 'center'
  }
}))

export const GradientTitle = styled(Typography)(() => ({
  fontSize: '24px',
  fontWeight: 600,
  background: `linear-gradient(135deg, ${theme.palette.neutral[200]} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.secondary.main} 100%)`,
  backgroundSize: '200% 200%',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  animation: `${gradientShift} 4s ease-in-out infinite`,
  textAlign: 'center',
  lineHeight: 1.3
}))
